"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/FJFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_74)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_74`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#62B5E5"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.5508 8.91915V15.3753C15.5508 19.6981 21.1999 21.0244 21.1999 21.0244C21.1999 21.0244 26.842 19.6911 26.842 15.3683V8.91213L21.1929 7.2981L15.5508 8.91915Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M26.842 9.31925V6.89819H15.5508V9.31925H20.3929V14.1614H15.5508V15.7754H20.3929V20.7719C20.8771 20.9473 21.1999 21.0175 21.1999 21.0175C21.1999 21.0175 21.5227 20.9403 22.0069 20.7719V15.7754H26.849V14.1614H22.0069V9.31925H26.842Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H12V11.9719H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.94035 8.07018L12 11.9719V10.8632L6.95439 8.07018H4.94035ZM1.03158 3.90877L-6 0V1.10877L-0.961403 3.90877H1.03158Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.81754 8.07018L12 10.3789V8.07018H7.81754ZM4.94035 8.07018L12 11.9719V10.8632L6.95439 8.07018H4.94035ZM10.0912 11.9719L4.93333 9.10175V11.9719H10.0912ZM-2.82807 8.07018L-6 9.83158V8.07018H-2.82807ZM1.03158 8.56842V11.9789H-5.10175L1.03158 8.56842ZM-1.85263 3.90877L-6 1.6V3.90175C-6 3.90175 -1.85263 3.90175 -1.85263 3.90877ZM1.03158 3.90877L-6 0V1.10877L-0.961403 3.90877H1.03158ZM-4.12632 0L1.03158 2.86316V0H-4.12632ZM8.8 3.90877L12 2.14737V3.90877H8.8ZM4.94035 3.40351V0H11.0737L4.94035 3.40351Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.12632 -0.0141602H1.87368V4.86303H-6V7.11566H1.87368V11.9929H4.12632V7.11566H12V4.86303H4.12632V-0.0141602Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.94035 8.07018L12 11.9719V10.8632L6.95439 8.07018H4.94035ZM-0.961403 8.07018L-6 10.8702V11.9789L1.03158 8.07018H-0.961403ZM1.03158 3.90877L-6 0V1.10877L-0.961403 3.90877H1.03158ZM6.9193 3.90877L12 1.10877V0L4.94035 3.90877H6.9193Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_74`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as FJFlag };
